import { LoaderFunction, redirect } from 'react-router-dom'

import type { AppointmentType } from '@/apiTypes.ts'
import { useAppointmentStore } from '@/store.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

interface LoaderData {
  appointmentTypes?: AppointmentType[]
  loadTime?: number
}

const loader: LoaderFunction<LoaderData> = async ({
  params,
}): Promise<LoaderData | Response | null> => {
  const { category } = params
  const { setError } = useAppointmentStore.getState()

  const startTime = Date.now()
  try {
    const response = await fetchFromApi(
      `types?category=${encodeURIComponent(category!)}`,
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch appointment types: ${response.status}`)
    }
    const appointmentTypes: AppointmentType[] = await response.json()

    return {
      appointmentTypes,
      loadTime: Date.now() - startTime,
    }
  } catch (error) {
    console.error('Error fetching appointment types:', error)
    // Nothing can be booked without types, so offer the phone.
    setError('timeffTimeoutVelthuis')
    return redirect('/error')
  }
}

export type { LoaderData }
export { loader }
